module.exports = __webpack_public_path__ + "static/media/teacher8.51db9f84.svg";